import React, { Component } from 'react';
import ModelServices from '../../accreditamento/services/Ente';
import { Link } from 'react-router-dom'
import { Breadcrumb, Card, Tabs, Button, notification, Row } from 'antd'
import { Sticky, StickyContainer } from 'react-sticky';
import Wrapper from '@common/decorators/Wrapper';
import CheckPermissions from '@common/decorators/CheckPermissions';
import SpinnerLoading from '@common/components/SpinnerLoading';
import DatiNuovoLR from '../components/DatiNuovoLR';

const TabPane = Tabs.TabPane;

@Wrapper({ route: 'accreditamenti', hasSidebar: true, hasHeader: true, hasFooter: true })
@CheckPermissions(['ListEnte', 'adminPermissions'])
class InserisciNuovoRL extends Component {

    state = {
        ente: {},
        current_key: "1",
        loading: true,
        sospensione: null
    }

    componentDidMount() {
        this.loadEnte(this.props)
    }

    renderTabBar(props, DefaultTabBar) {
        return (
            <Sticky bottomOffset={80}>
                {({ style }) => (
                    <DefaultTabBar {...props} style={{ ...style, zIndex: 1, background: '#fff' }} />
                )}
            </Sticky>
        )
    }

    loadEnte(props) {
        this.setState({ loading: true });
        ModelServices.view(
            {
                expand: [
                    'contatti', 'enteSede', 'enteSede.indirizzo', 'rappresentanteLegale', 'rappresentanteLegale.contatti', 'rappresentanteLegale.conAnagraficaIndirizzi', 'rappresentanteLegale.conAnagraficaIndirizzi.indirizzo', 'media'
                ].join(',')
            },
            props.match.params.id,
            res => {
                this.setState({ ente: res.data.data, loading: false });
            },
            e => { this.setState({ loading: false }) }
        );
    }

    capitalizeFirstLetter(string) {
        if (!string) return ""; // Controllo per stringhe vuote o non definite
        return string.charAt(0).toUpperCase() + string.slice(1);
      }

    render() {
        return (
            <div> {this.state.loading ? <SpinnerLoading message='Caricamento dati...' /> :
                <div>
                    <Card
                        style={{ marginBottom: '12px', backgroundColor: '#fff' }}
                        bordered={false}
                    >
                        <h3 className="sectionTitle">{this.capitalizeFirstLetter(this.state.ente.denominazione)}</h3>

                    </Card>
                    <div style={{ padding: '12px' }}>
                        <Breadcrumb>
                            <Breadcrumb.Item><Link to="/dashboard">Home</Link></Breadcrumb.Item>
                            <Breadcrumb.Item><Link to="/gestionelr">Gestione Rappresentante Legale</Link></Breadcrumb.Item>
                            <Breadcrumb.Item>{this.capitalizeFirstLetter(this.state.ente.denominazione)}</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>

                    <Card style={{ marginTop: 12, marginBottom: 12 }}
                        bodyStyle={{ paddingTop: 0, paddingBottom: 0 }}
                        bordered={false}>
                            <DatiNuovoLR
                                {...this.props}
                                ente={this.state.ente}
                            ></DatiNuovoLR>
                    </Card>
                </div>

            }
            </div>
        )
    }
}

export default InserisciNuovoRL